export default __webpack_public_path__ + "static/video-c3337b5c6340fe09d6b8ff3d9a41c720.ogv";